class ProductSlider {
  constructor(container) {
    this.container = container;
    this.wrapper = container.querySelector('.product-slider-wrapper');
    this.track = container.querySelector('.product-slider-track');
    this.prevButton = container.querySelector('.product-slider-button--prev');
    this.nextButton = container.querySelector('.product-slider-button--next');
    this.scrollbarThumb = container.querySelector('.product-slider-scrollbar-thumb');
    this.scrollbarTrack = container.querySelector('.product-slider-scrollbar-track');
    
    this.init();
  }

  init() {
    if (!this.wrapper || !this.track) {
      return;
    }

    // Check item count and toggle centering
    this.checkItemCount();

    // Initialize scrollbar
    this.updateScrollbar();
    this.updateButtonStates();

    // Event listeners for buttons
    if (this.prevButton) {
      this.prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.scrollPrev();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.scrollNext();
      });
    }

    // Event listener for scroll
    this.wrapper.addEventListener('scroll', () => {
      this.updateScrollbar();
      this.updateButtonStates();
    });

    // Event listener for scrollbar thumb drag
    if (this.scrollbarThumb && this.scrollbarTrack) {
      this.initScrollbarDrag();
    }

    // Update on resize
    window.addEventListener('resize', () => {
      this.checkItemCount();
      this.updateScrollbar();
      this.updateButtonStates();
    });
  }

  checkItemCount() {
    const items = this.track.querySelectorAll('.product-slider-item');
    const itemCount = items.length;

    if (itemCount < 4) {
      this.container.classList.add('product-slider-container--centered');
    } else {
      this.container.classList.remove('product-slider-container--centered');
    }
  }

  isRTL() {
    return getComputedStyle(this.wrapper).direction === 'rtl';
  }

  scrollPrev() {
    const scrollAmount = this.wrapper.clientWidth * 0.8;
    const direction = this.isRTL() ? -scrollAmount : -scrollAmount;
    this.wrapper.scrollBy({
      left: direction,
      behavior: 'smooth'
    });
  }

  scrollNext() {
    const scrollAmount = this.wrapper.clientWidth * 0.8;
    const direction = this.isRTL() ? scrollAmount : scrollAmount;
    this.wrapper.scrollBy({
      left: direction,
      behavior: 'smooth'
    });
  }

  updateButtonStates() {
    // buttons always active
  }

  updateScrollbar() {
    if (!this.scrollbarThumb || !this.wrapper) return;

    const scrollPercentage = this.wrapper.scrollLeft / (this.wrapper.scrollWidth - this.wrapper.clientWidth);
    const thumbWidth = (this.wrapper.clientWidth / this.wrapper.scrollWidth) * 100;
    const thumbPosition = scrollPercentage * (100 - thumbWidth);

    this.scrollbarThumb.style.width = `${thumbWidth}%`;
    this.scrollbarThumb.style.left = `${thumbPosition}%`;
  }

  initScrollbarDrag() {
    let isDragging = false;

    const handleDrag = (e) => {
      if (!isDragging) return;

      const trackRect = this.scrollbarTrack.getBoundingClientRect();
      const clickPosition = e.clientX - trackRect.left;
      const clickPercentage = clickPosition / trackRect.width;
      
      const scrollPosition = clickPercentage * (this.wrapper.scrollWidth - this.wrapper.clientWidth);
      this.wrapper.scrollLeft = scrollPosition;
    };

    this.scrollbarThumb.addEventListener('mousedown', (e) => {
      isDragging = true;
      e.preventDefault();
    });

    document.addEventListener('mousemove', handleDrag);

    document.addEventListener('mouseup', () => {
      isDragging = false;
    });

    // Allow clicking on track to jump
    this.scrollbarTrack.addEventListener('click', (e) => {
      if (e.target === this.scrollbarThumb) return;
      
      const trackRect = this.scrollbarTrack.getBoundingClientRect();
      const clickPosition = e.clientX - trackRect.left;
      const clickPercentage = clickPosition / trackRect.width;
      
      const scrollPosition = clickPercentage * (this.wrapper.scrollWidth - this.wrapper.clientWidth);
      this.wrapper.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    });
  }
}

// Initialize function
function initProductSliders() {
  const productSliders = document.querySelectorAll('.product-slider-container');
  productSliders.forEach(slider => {
    // Avoid re-initializing
    if (slider.dataset.initialized) {
      return;
    }
    slider.dataset.initialized = 'true';
    new ProductSlider(slider);
  });
}

// Initialize all product sliders on the page
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductSliders);
} else {
  // DOM already loaded
  initProductSliders();
}

// Reinitialize on Shopify section load (for theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const slider = event.target.querySelector('.product-slider-container');
    if (slider) {
      slider.dataset.initialized = 'false';
      new ProductSlider(slider);
    }
  });
}
